import { FormControl, InputLabel } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { HelperText } from "../../../../components/Errors/HelperText";
import { WhiteInput } from "../../../../components/Inputs/InputText";
import styles from "../Cadastro.module.css";
import InputMask from "react-input-mask";
import { UFPersonalizado } from "../../../../components/Combobox/UFPersonalizado";
import { CidadesSearchField } from "../../../../components/Searchfields/Cidades";
import { faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Container } from "@mui/material";
import { useEffect } from "react";

const Localizacao = ({ setIsLoading, setOpenError, setErrorMessage, camposDesabilitados, onKeyDown, podeSalvar }) => {
const { control, register, setValue, watch, setError, clearErrors, formState: { errors } } = useFormContext();
    const watchCodigoCidade = watch("codigoCidade");
    const watchUf = watch("uf");

    useEffect(() => {
        if (watchCodigoCidade) {
            setValue("Cidade", { value: watchCodigoCidade.value, label: watchCodigoCidade.label });
            clearErrors('Cidade');
        }
    }, [watchCodigoCidade]);

    return (
        <Container sx={{display: "flex", alignItems: "center", width: "100%" }}>
            <div style={{ width: "100%" }}>
            <div className={styles['input-container']}>
                <Controller 
                     name="codigoCidade"
                     control={control}
                     render={({field}) => (
                         <FormControl variant="outlined" style={{ zIndex: 3 }}>
                             <InputLabel htmlFor="consulta-cidades" shrink sx={{ color: "#b8b8b8" }}>Cidade <FontAwesomeIcon title="Para facilitar a procura, digite o nome da cidade desejada no campo abaixo." style={{ marginLeft: "10px", width: "15px", height: "15px", cursor: "pointer"}} icon={faQuestionCircle} /></InputLabel>
                             <CidadesSearchField
                                 field={field}
                                 id="consulta-cidades" 
                                 setOpenError={setOpenError}
                                 setErrorMessage={setErrorMessage}
                                 disabled={camposDesabilitados} 
                                 onKeyDown={onKeyDown}
                                 className={`${errors?.Cidade ? styles.campoComValorErrado : ""}`}
                             />
                             { errors?.Cidade ?  (
                                     <HelperText text={errors?.Cidade.value?.message} />
                             ) : '' }
                         </FormControl>
                     )}
                 />

                <Controller 
                    name="endereco"
                    control={control}
                    render={({field}) => (
                        <FormControl variant="outlined">
                            <InputLabel htmlFor="consulta-endereco" shrink sx={{ color: "#b8b8b8" }}>Endereço</InputLabel>
                            <WhiteInput
                                fullWidth 
                                placeholder="Endereço" 
                                type="text" 
                                id="consulta-endereco" 
                                name="endereco" 
                                {...field} 
                                readOnly={camposDesabilitados} 
                                autoComplete="off"
                                onKeyDown={onKeyDown}
                                className={`${errors?.endereco ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.endereco ?  (
                                    <HelperText text={errors?.endereco?.message} />
                            ) : '' }
                        </FormControl>
                    )}
                />


            </div>
            <div className={styles['input-ocupante']}  style={{ padding: "0px 10px 10px 10px" }}>
                <Controller 
                    name="bairro"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" sx={{width: "100%"}}>
                            <InputLabel htmlFor="consulta-bairro" shrink sx={{ color: "#b8b8b8" }}>Bairro</InputLabel>
                            <WhiteInput
                                fullWidth 
                                placeholder="Bairro" 
                                type="text" 
                                id="consulta-bairro" 
                                name="bairro" 
                                {...field} 
                                readOnly={camposDesabilitados} 
                                autoComplete="off"
                                onKeyDown={onKeyDown}
                                className={`${errors?.bairro ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.bairro ?  (
                                    <HelperText text={errors?.bairro?.message} />
                            ) : '' }
                        </FormControl>
                    )} 
                />
            </div>

            <div className={styles['input-ocupante']} style={{ padding: "20px 10px" }}>
                <Controller 
                    name="cep"
                    control={control}
                    render={({ field: { onChange, value }}) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="consulta-cep" shrink sx={{ color: "#b8b8b8" }}>CEP</InputLabel>
                            <InputMask
                                mask="99999-999"
                                onChange={onChange}
                                value={value}
                                id="consulta-cep"
                                readOnly={camposDesabilitados}
                            >
                                { inputProps => (
                                    <WhiteInput
                                        fullWidth 
                                        placeholder="CEP"
                                        name="cep" 
                                        {...inputProps}
                                        onKeyDown={onKeyDown}
                                        autoComplete="off"
                                        className={`${errors?.cep ? styles.campoComValorErrado : ""}`}
                                        readOnly={camposDesabilitados}
                                    />
                                )}
                            </InputMask>
                            { errors?.cep ?  (
                                    <HelperText text={errors?.cep?.message} />
                            ) : '' }
                        </FormControl>
                    )} 
                />
                <Controller 
                    name="uf"
                    control={control}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="consulta-uf" shrink sx={{ color: "#b8b8b8" }}>UF</InputLabel>
                            <UFPersonalizado 
                                field={field}
                                id="consulta-uf"
                                name="Consulta UF"
                                placeholder="Selecione um estado"
                                readOnly={camposDesabilitados}
                                disabled={camposDesabilitados}
                                onKeyDown={onKeyDown}
                                className={`${errors?.uf ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.uf ?  (
                                    <HelperText text={errors?.uf?.message} />
                            ) : '' }
                        </FormControl>
                    )} 
                />
            </div>
            <div className={styles['input-container']} style={{ padding: "20px 10px" }}>
                <Controller 
                    name="numero"
                    control={control}
                    rules={{ valueAsNumber: true }}
                    render={({ field }) => (
                        <FormControl variant="outlined" className={styles['campos-m']}>
                            <InputLabel htmlFor="consulta-numero" shrink sx={{ color: "#b8b8b8" }}>Número</InputLabel>
                            <WhiteInput
                                fullWidth 
                                placeholder="Número" 
                                type="number" 
                                id="consulta-numero" 
                                name="numero" 
                                autoComplete="off"
                                {...field} 
                                readOnly={camposDesabilitados} 
                                onKeyDown={onKeyDown}
                                className={`${errors?.Numero ? styles.campoComValorErrado : ""}`}
                            />
                            { errors?.Numero ?  (
                                    <HelperText text={errors?.Numero?.message} />
                            ) : '' }
                        </FormControl>
                    )} 
                />
            </div>
        </div>
        
    </Container>
    );
}

export { Localizacao }